"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledNumberFormat = (0, _styledComponents.default)(_reactNumberFormat.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: inherit;\n  line-height: inherit;\n"])));

var PenceToPounds = function PenceToPounds(_ref) {
  var children = _ref.children,
      hideDecimals = _ref.hideDecimals,
      showCurrencySymbol = _ref.showCurrencySymbol,
      isDutch = _ref.isDutch;
  var pounds = (children / 100).toString();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [showCurrencySymbol && process.env.REACT_APP_CURRENCY_SYMBOL, /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactNumberFormat.default, {
      displayType: "text",
      value: children / 100,
      decimalScale: hideDecimals || isDutch && pounds.indexOf(".") === -1 ? 0 : 2,
      decimalSeparator: isDutch ? "," : ".",
      fixedDecimalScale: !hideDecimals,
      thousandSeparator: isDutch ? "." : ",",
      suffix: isDutch && pounds.indexOf(".") === -1 && ",-"
    })]
  });
};

var _default = PenceToPounds;
exports.default = _default;